import FormGroup from "legacy/FormGroup"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class RegistrationForm extends React.Component {
  render() {
    return (
      <div className="row nested-row">
        <h3 className={this.props.headerClassName || "mt-0 text-xl"}>
          Registration or Documentation
        </h3>
        <div className="col-xs-6">
          <FormGroup
            disabled={this.props.disabled}
            name="registration.number"
            label="Registration Number"
            labelClassName={this.props.labelClassName}
            placeholder={this.props.optional && "(Optional)"}
            value={
              (this.props.registration && this.props.registration.number) || ""
            }
            onChange={this.props.setParentState}
            validation={this.props.validator.message(
              "registration_number",
              !this.props.optional &&
                this.props.registration &&
                this.props.registration.number,
              "required"
            )}
          />
        </div>
        <div className="col-xs-6">
          <FormGroup
            disabled={this.props.disabled}
            name="registration.expirationDate"
            label="Expiration Date"
            labelClassName={this.props.labelClassName}
            placeholder={this.props.optional && "(Optional)"}
            value={
              (this.props.registration &&
                this.props.registration.expirationDate) ||
              ""
            }
            inputType="datepicker"
            validation={this.props.validator.message(
              "registration_expiration_date",
              !this.props.optional &&
                this.props.registration &&
                this.props.registration.expirationDate &&
                moment(this.props.registration.expirationDate),
              ["required", { after_or_equal: moment() }]
            )}
            startDate={moment()}
            onChange={(expirationDate) =>
              this.props.setParentState({
                target: {
                  name: "registration.expirationDate",
                  value: moment(expirationDate).format("YYYY-MM-DD"),
                },
              })
            }
          />
        </div>
      </div>
    )
  }
}

RegistrationForm.propTypes = {
  disabled: PropTypes.bool,
  headerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  optional: PropTypes.bool,
  registration: PropTypes.shape({
    number: PropTypes.string,
    expirationDate: PropTypes.string,
  }),
  setParentState: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
}

RegistrationForm.defaultProps = {
  disabled: false,
  optional: false,
  registration: {},
}

export default RegistrationForm
